module.exports = __webpack_public_path__ + "static/media/icon-convenio.03324971.svg";